import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { ExportResponseResource } from '@models/resource/export-response.resource';
import { ExportLog } from '../models/export-log.model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../services/app-config.service';
import { ReportParams } from '../models/resource/reporting.resource';
import { ReportRequestParams } from '../models/resource/report-request-params.resource';
import { SearchReportExportRequest } from '../models/search-report-export-request.model';

@Injectable({ providedIn: 'root' })
export class ExportSdk extends SdkBase {

	constructor(injector: Injector, private http: HttpClient, private appConfigService: AppConfigService,) {
        super(injector);
    }

    public exportAudits(): Observable<string> {
        return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/audits', null).pipe(
            map(((response) => response.downloadUrl))
        );
    }

    public exportAccounts(accountId: string): Observable<string> {
        return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/accounts', { accountId }).pipe(
            map(((response) => response.downloadUrl))
        );
    }

	public exportDocNotes(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/docnotes', { }).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportAssistedReviewReport(assistedReviewJobId: string): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', `api2/export/assistedreview/${assistedReviewJobId}`, { }).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportFacts(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/facts', {}).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportFactsPivot(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/factspivot', {}).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportLoginTracker(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/LoginTrackers', {}).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportUsers(userIds: string[]): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/users', { userIds }).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportContacts(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/contacts', {}).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportCustodians(): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/custodians', {}).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportLog(payload: ExportLog): Observable<string> {
		return this.http.post<ExportResponseResource>(`${this.appConfigService.getConfig().webApi}/api2/export/log`, payload)
			.pipe(
				map(((response) => response.downloadUrl)));
	}

	public exportReport(params: ReportParams = null): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/reporting', params).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportReviewTracking(params: ReportRequestParams = null): Observable<string> {
		return this.makeHttpRequest<ExportResponseResource>('post', 'api2/export/reviewTracking', params).pipe(
			map(((response) => response.downloadUrl))
		);
	}

	public exportUsages(accountId: string): Observable<string> {
		return this.http.post<ExportResponseResource>(`${this.appConfigService.getConfig().webApi}/api2/export/usagesAccountBilling/${accountId}`, {})
			.pipe(
				map(((response) => response.downloadUrl))
		);
	}

	public exportSearchReport(exportRequest: SearchReportExportRequest): Observable<string> {
		return this.http.post<ExportResponseResource>(`${this.appConfigService.getConfig().webApi}/api2/export/searchReports/${exportRequest.searchReportId}`, exportRequest)
			.pipe(
				map(((response) => response.downloadUrl))
			);
	}
}

